import { App, Profile } from 'types/StartupTypes';

import { AxiosInstance } from 'axios';
import { ConfigurationService } from './ConfigurationService';
import { Result } from 'types/CodegenResult';
import i18next from 'i18next';

export class StartupService {
  private axiosInstance: AxiosInstance;
  private configService: ConfigurationService;

  constructor(axiosInstance: AxiosInstance, configService: ConfigurationService) {
    this.axiosInstance = axiosInstance;
    this.configService = configService;
  }

  getConfigs = async () => {
    return await this.configService.getConfigs();
  };

  getAllApps = async (identityUrl: string) => {
    const response = await this.axiosInstance.get<Result<App[] | { data: App[] }>>(`${identityUrl}/api/v1/me/apps`);
    if (response.data && !response.data.isError && response.data.data) {
      return !Array.isArray(response.data.data) ? response.data.data?.data : response.data.data; // Needed for backward compatibility with old IDv1 API
    }
    throw Error(i18next.t('internalError.getAllApps'));
  };

  getProfile = async () => {
    const response = await this.axiosInstance.get<Result<Profile>>(`account/profile`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(i18next.t('internalError.getProfile'));
  };

  getPermissions = async () => {
    const response = await this.axiosInstance.get<Result<{ permissions: string[] }>>(`account/privileges`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(i18next.t('internalError.getPermissions'));
  };
}

export default StartupService;
